import { createUseStyles } from 'react-jss';

export default createUseStyles({
  paginationBar: {
    '& > ul': {
      justifyContent: 'center',
    },
  },

  paginationItem: {
    '& > a': {
      backgroundColor: 'white',
      color: '#102131',
    },

    '&:hover > a': {
      backgroundColor: '#FAFCFF',
      background: 'none',
      color: '#102131',
      zIndex: 0,
    },
  },

  paginationLink: {
    border: 'none',

    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    textAlign: 'center',
    backgroundColor: 'transparent',
  },

  active: {
    '& > a': {
      background: 'linear-gradient(119.56deg, #C8D8E1 0%, #AABAC5 100%)',
      color: 'white',
    },
    '&:hover > a': {
      backgroundColor: 'transparent',
      background: 'linear-gradient(119.56deg, #C8D8E1 0%, #AABAC5 100%)',
      color: 'white',
      zIndex: 0,
    },
  },

});
